import React, { useState } from 'react';

import './_survey.scss';

import SparkSolid from '../../../../Icons/icons/SparkSolid';
import { useSurveyContext } from './surveyContext';

const SurveyProgress = () => {
  const { surveyFormStep, totalSteps, userType } = useSurveyContext();
  const actualStep = userType === 'v2' ? surveyFormStep - 4 : surveyFormStep;
  const percentComplete = (actualStep / totalSteps) * 100;

  const [v2Header, setV2Header] = useState(userType === 'v2' ? true : false);
  return (
    <>
      <div className="survey-progress-container">
        <div className="survey-progress-background-bar" />
        <div className="survey-progress-bar" style={{ width: `${percentComplete}%` }} />
        <SparkSolid className="survey-progress-sparkle" style={{ left: `calc(${percentComplete}% - 15px)` }} />
      </div>
      {v2Header && (actualStep === 1 || actualStep === 2) && (
        <div className="survey-v2-header">
          <h4>Congrats on getting the trial!</h4>
          <div>
            <p>
              {actualStep === 1
                ? 'To help you make the most of your access, help us with the answers below'
                : 'One last question...'}
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default SurveyProgress;
